import { memo } from "react";
import type { GridRenderCellParams } from "@mui/x-data-grid-premium";
import Typography from "@mui/material/Typography";
import When from "ui/support/When";
import type { OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges } from "../types";

const PerformedBy = ({ row }: GridRenderCellParams<OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges>) => (
    <When
        if={Boolean(row.touchedBy)}
        then={(
            <Typography
                variant='subtitle2'
            >
                {row.touchedBy} ({row.updatedByUserId})
            </Typography>
        )}
    />
);

export default memo(PerformedBy);
